<template>
  <div class="cp-set-commerce-agent-message main">
    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-bullhorn icon" />Commerce Agent Message</p>
      <div style="margin-top: 10px">
        <textarea
          class="textarea"
          v-model="message"
          placeholder="Enter message for commerce agents"
          rows="4"
        />
      </div>
      <div class="save-wrapper">
        <p v-if="updatingMessage" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else>
          <span
            class="button is-pulled-left has-text-grey"
            @click="clearMessage"
            ><i class="far fa-trash-alt"
          /></span>
          <span class="button has-text-success" @click="saveMessage">Save</span>
        </p>
      </div>
    </div>

    <!-- <div class="divider" />

    <div class="row">
      <p><i class="fa fa-globe-asia icon" />Region</p>
      <p class="value">
        {{ $t(`country.${business.country}`) }}
        <span class="hint link is-pulled-right" @click="changeRegion">
          Change
        </span>
      </p>
    </div> -->
  </div>
</template>


<script>
export default {
  name: "CPSetCommerceAgentMessage",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      message: null,
      updatingMessage: false,
    };
  },
  computed: {
    business() {
      return this.b;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
  },
  mounted() {
    this.message = this.commerce.data.commerce_agent_message;
  },
  methods: {
    clearMessage() {
      this.message = null;
      this.saveMessage;
    },
    saveMessage() {
      this.updatingMessage = true;
      var obj = {
        commerce_agent_message: this.message,
      };
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.commerce.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated commerce_agent_message");
          this.commerce.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingMessage = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
  overflow: hidden;
  max-width: 600px;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.hint {
  font-size: 0.8em;
  font-weight: 500;
}
</style>
